import { rows, dateValue } from "./appData";
export const chatIdFor = (uid, id) => [uid, id].sort().join("_");
export const messageVisible = (m, uid) =>
  m &&
  m.deleted !== true &&
  !m.deletedFor?.[uid] &&
  !(m.deleted && m.movedToTrash);
export const messageSeen = (m, uid, group = false) =>
  group
    ? Boolean(m.seenBy?.[uid] || m.isSeen?.[uid])
    : m.seen === true || m.seenBy?.[uid] === true || m.isSeen?.[uid] === true;
export function threadSummary(data, uid, group = false) {
  const messages = rows(data)
    .filter((m) => messageVisible(m, uid))
    .sort(
      (a, b) =>
        dateValue(b.timestamp || b.createdAt) -
        dateValue(a.timestamp || a.createdAt),
    );
  const last =
    messages.find((m) => m.type !== "call" || m.callStatus === "missed") ||
    messages[0];
  const unread = messages.filter(
    (m) => m.senderId !== uid && !messageSeen(m, uid, group),
  ).length;
  let text =
    last?.text ||
    (last?.imageUrl
      ? "📷 Photo"
      : last?.audioUrl
        ? "🎤 Voice message"
        : last?.videoUrl
          ? "📹 Video"
          : last?.type === "poll"
            ? "📊 Poll"
            : last?.type === "job_hired"
              ? "Freelancer hired for a job"
              : "");
  if (last?.type === "call")
    text = last.senderId === uid ? "Call (no answer)" : "Missed call";
  return {
    unread,
    message: text,
    lastTimestamp: dateValue(last?.timestamp || last?.createdAt),
    hasMessages: messages.length > 0,
  };
}
export function inboxRows(state, currentUser) {
  const uid = currentUser?.uid;
  if (!uid) return [];
  const me = state.users?.[uid] || currentUser;
  const out = [
    {
      id: uid,
      type: "dm",
      isSelf: true,
      name: `${currentUser.name || me.name || "Me"} (You)`,
      profilePic: currentUser.profilePic || me.profilePic,
      message: "Message yourself",
      unread: 0,
      lastTimestamp: Infinity,
    },
  ];
  for (const user of rows(state.users)) {
    if (user.id === uid) continue;
    const summary = threadSummary(state.threads?.["dm:" + user.id], uid);
    const isFriend = Boolean(me.friends?.[user.id]);
    const isRequest = Boolean(
      me.requestChats?.[user.id] ||
      me.friendRequests?.[user.id] === "received" ||
      user.friendRequests?.[uid] === "sent",
    );
    const blocked = Boolean(me.blockedUsers?.[user.id]);
    if (!isFriend && !isRequest && !blocked && !summary.hasMessages) continue;
    const key = chatIdFor(uid, user.id);
    if (
      Number(me.hiddenChats?.[user.id] || me.hiddenChats?.[key] || 0) >=
        summary.lastTimestamp &&
      (me.hiddenChats?.[user.id] || me.hiddenChats?.[key])
    )
      continue;
    const typing = me.typingstatus?.[key]?.[user.id];
    const typingNow = Boolean(
      typing?.status && Date.now() - Number(typing.timestamp || 0) < 4000,
    );
    out.push({
      ...user,
      ...summary,
      typing: typingNow,
      type: "dm",
      name: user.name || user.displayName || user.username || "Creator",
      isFriend,
      isRequest,
      blocked,
      pinned: Boolean(me.pinnedChats?.[user.id]),
      muted: Boolean(me.mutedChats?.[key] || me.mutedChats?.[user.id]),
      message: summary.message || "Say hi 👋",
    });
  }
  for (const group of rows(state.groups)) {
    if (group.hostId !== uid && !group.members?.[uid]) continue;
    const summary = threadSummary(
      state.threads?.["group:" + group.id],
      uid,
      true,
    );
    if (
      me.hiddenChats?.[group.id] &&
      Number(me.hiddenChats[group.id]) >= summary.lastTimestamp
    )
      continue;
    const typing = Object.keys(group.members || {}).some((id) => {
      const item = state.users?.[id]?.typingstatus?.groups?.[group.id]?.[id];
      return (
        id !== uid &&
        item?.status &&
        Date.now() - Number(item.timestamp || 0) < 4000
      );
    });
    out.push({
      ...group,
      ...summary,
      typing,
      type: "group",
      profilePic: group.photo || group.profilePic,
      pinned: Boolean(me.pinnedGroups?.[group.id]),
      muted: Boolean(me.mutedChats?.[group.id]),
      message: summary.message || "No messages yet",
    });
  }
  return out.sort(
    (a, b) =>
      Number(b.isSelf || false) - Number(a.isSelf || false) ||
      Number(b.pinned || false) - Number(a.pinned || false) ||
      b.lastTimestamp - a.lastTimestamp,
  );
}
export function filterInbox(list, tab, search = "", niche = "") {
  const query = search.trim().toLowerCase();
  return list.filter((row) => {
    if (tab === "Blocked")
      return (
        row.blocked &&
        row.type === "dm" &&
        `${row.name} ${row.niche || ""}`.toLowerCase().includes(query)
      );
    if (row.blocked) return false;
    if (
      query &&
      !`${row.name} ${row.niche || ""}`.toLowerCase().includes(query)
    )
      return false;
    if (niche && row.niche !== niche) return false;
    if (tab === "DMs" && row.type !== "dm") return false;
    if (tab === "Groups" && row.type !== "group") return false;
    if (tab === "Unread" && !row.unread) return false;
    if (tab === "Requests" && !row.isRequest) return false;
    return true;
  });
}
